import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export function LanguageSelector() {
    const { lang, setLang } = useLanguage();

    return (
        <div className="language-switcher">
            <select
                value={lang}
                onChange={(e) => setLang(e.target.value as 'tr' | 'en')}
                className="language-select"
            >
                <option value="tr">Türkçe</option>
                <option value="en">English</option>
            </select>
        </div>
    );
}